import { Check, Loader2, AlertTriangle } from "lucide-react";
import type { SaveStatus } from "@/types/maturity";

type SaveIndicatorProps = {
  status: SaveStatus;
  inline?: boolean;
  onRetry?: () => void;
};

function SaveIndicator({ status, inline, onRetry }: SaveIndicatorProps) {
  if (status === "idle") return null;

  const base = inline
    ? "inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold shadow-sm transition-all"
    : "fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-semibold shadow-lg transition-all";

  if (status === "saving") {
    return (
      <div
        className={`${base} bg-white border border-slate-200 text-slate-500`}
      >
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
        Se salvează...
      </div>
    );
  }

  if (status === "saved") {
    return (
      <div
        className={`${base} bg-emerald-50 border border-emerald-200 text-emerald-700`}
      >
        <Check className="w-3.5 h-3.5" />
        Salvat automat
      </div>
    );
  }

  return (
    <div className={`${base} bg-red-50 border border-red-200 text-red-600`}>
      <AlertTriangle className="w-3.5 h-3.5" />
      Eroare la salvare
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="ml-2 underline text-red-700 hover:text-red-800"
        >
          Reîncearcă
        </button>
      )}
    </div>
  );
}

export default SaveIndicator;
